import { AssignToCurrentIteration } from './AssignToCurrentIteration';
import { AssignToTeamAction } from './AssignToTeamAction';
import { DeleteConnectedPageAction } from './DeleteConnectedPageAction';
import { RemoveFromIteration } from './RemoveFromIteration';
import { OpenInNewTabAction } from './OpenInNewTabAction';
import { MoveToPrioritizedBacklogAction } from './MoveToPrioritizedBacklogAction';
import { RemoveFromPrioritizedBacklogAction } from './RemoveFromPrioritizedBacklogAction';
import { AssignToUserAction } from './AssignToUserAction';
import { BulkEditAction } from './BulkEditAction';
import { CopyLinkAction } from './CopyLinkAction';
import { CopyRecordAction } from './CopyRecordAction';
import { LinkToRecordAction } from './LinkToRecordAction';
import { DeleteRecordAction } from './DeleteRecordAction';
import { MoveToTopAction } from './MoveToTopAction';
import { MoveToBottomAction } from './MoveToBottomAction';
import { MoveToReleaseAction } from './MoveToReleaseAction';
import { UpdateStatusAction } from './UpdateStatusAction';
import { MoveToWorkflowBoardAction } from './MoveToWorkflowBoardAction';
import { UnassignFromTeamAction } from './UnassignFromTeamAction';
import { FlagAtRiskAction } from './FlagAtRiskAction';
import { RemoveAtRiskAction } from './RemoveAtRiskAction';
import { PromoteToWorkspaceAction } from './PromoteToWorkspaceAction';
import { SortChildPagesAction } from './SortChildPagesAction';
import { SaveAsTemplateAction } from './SaveAsTemplateAction';
import type RecordAction from '../RecordAction';
import { MovePageAction } from './MovePageAction';
import { EditLinkAction } from './EditLinkAction';

type ActionGroup = {
  type: 'common' | 'extension';
  actions: Array<{ new (...args: any[]): RecordAction<any> }>;
};

// Determines the order and groups for actions. Groups are divided by
// <aha-menu>.
const recordActionGroups: Array<ActionGroup> = [
  {
    type: 'common',
    actions: [
      BulkEditAction,
      OpenInNewTabAction,
      CopyLinkAction,
      SortChildPagesAction,
      EditLinkAction,
    ],
  },
  {
    type: 'common',
    actions: [
      AssignToUserAction,
      AssignToTeamAction,
      UnassignFromTeamAction,
      UpdateStatusAction,
      LinkToRecordAction,
      FlagAtRiskAction,
      RemoveAtRiskAction,
    ],
  },
  {
    type: 'common',
    actions: [
      AssignToCurrentIteration,
      RemoveFromIteration,
      MoveToWorkflowBoardAction,
      MoveToPrioritizedBacklogAction,
      RemoveFromPrioritizedBacklogAction,
      PromoteToWorkspaceAction,
      MoveToReleaseAction,
      MoveToTopAction,
      MoveToBottomAction,
    ],
  },
  // Placeholder to insert extension actions into the desired menu position
  { type: 'extension', actions: [] },
  {
    type: 'common',
    actions: [
      SaveAsTemplateAction,
      CopyRecordAction,
      MovePageAction,
      DeleteRecordAction,
      DeleteConnectedPageAction,
    ],
  },
];

export default recordActionGroups;
